// extracted by mini-css-extract-plugin
export default {"list":"ChooseUs_list__yEGV7","title":"ChooseUs_title__YXIHu","text":"ChooseUs_text__DQ6br"};